/* global axios */
import ApiClient from '../ApiClient';

// Account-level ElevenLabs control plane: the shared account EL key (write-only) and the
// voice-library proxy. NOT brain-scoped — one key per account (elevenlabs:default). The key is
// never returned; only `el_configured` is surfaced.
class AiAgentElevenlabs extends ApiClient {
  constructor() {
    super('ai_agents/elevenlabs', { accountScoped: true });
  }

  getConfig() {
    return axios.get(this.url);
  }

  voices() {
    return axios.get(`${this.url}/voices`);
  }

  setKey(apiKey) {
    return axios.put(`${this.url}/key`, { api_key: apiKey });
  }

  clearKey() {
    return axios.delete(`${this.url}/key`);
  }
}

export default new AiAgentElevenlabs();
